/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomStatusOverrideSelect.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import React from "react";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import CustomSelectV3 from "../common/select/CustomSelectV3";

const CustomStatusOverrideSelect = ({
  label = "Select Status",
  required = false,
  statusOptions = [],
  isOverrideChecked = false,
  setIsOverrideChecked = () => { },
  value = "",
  setValue = () => { },
  optionsList = [], // For CustomSelectV3
  infoname = "status_override",
  placeholder = "Select Status",
}) => {
  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsOverrideChecked(checked);
    if (!checked) setValue("");
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Override Checkbox */}
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(isOverrideChecked)}
            onChange={handleCheckboxChange}
            color="success"
          />
        }
        label="Status override (manual)"
      />

      {/* Your Custom Select instead of MUI Select */}
      <CustomSelectV3
        size="small"
        placeholder={placeholder}
        label={label}
        required={required}
        disabled={!isOverrideChecked}
        handleOnChange={(e) => setValue(e.target.value)}
        selectedValue={value}
        optionsList={
          optionsList.length > 0
            ? optionsList
            : statusOptions.map((item) => ({ label: item, value: item }))
        }
      />
    </Box>
  );
};

export default CustomStatusOverrideSelect;
